import React from 'react'
import {Route, Switch} from 'react-router-dom'

import Category from 'modules/Category'
import Products from 'modules/Products'

const RoutesNav = ({data}) => (
  <Switch>
    <Route exact path='/category/:alias' component={Category}/>
    <Route exact path='/search/:searchValue' render={({match}) => <Products match={match} data={data}/>}/>
  </Switch>
)

export default RoutesNav
